module.exports = __webpack_public_path__ + "img/full6-min.ecdf2bd3.png";